// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notice-main{
    width:calc(100vw - 202px);
    height: calc(100vh - 38px);
   
    background-color: #F4F9FF;
 }
 
 .notice-div{
     background-color: #FFFFFF;
     margin-left: 15px;
     position: absolute;
     margin-top: 15px;
     width: calc(100vw - 265px);
     /* height: calc(100vh - 100px); */
     height: 100vh;
     padding: 20px;
     box-shadow: 0px 0px 7px lightblue;
     border-radius: 5px;
     border: none;
    
 }


 
 
 
 .notice-min{
     width: calc(100vw - 100px);
     height: calc(100vh - 38px);
     background-color: #F4F9FF; 
 }
 
 .notice-div-min{
     background-color: #FFFFFF;
     margin-left: 15px;
     position: absolute;
     margin-top: 15px;
     width: calc(100vw - 165px);
     height: calc(100vh - 100px);
     padding: 20px;
     box-shadow: 0px 0px 7px lightblue;
     border-radius: 5px;
     border: none;
 }

 .notice-tab>div{
   background-color: transparent ;
   margin-top: 0px;
   justify-content: flex-start;
   left: auto;
   position: absolute !important;
   padding-top: 0px;
   width: 80% !important;
 }

 .notice-tab>div>div>button.Mui-selected{
   border: 1px solid gray;
   background-color: #0059B2;
   color: #FFFFFF !important;
   /* border-radius: 10px; */
   /* color: #0000ff !important; */
   /* transform: scale(1); */
 }

 .notice-main-form{
    display: flex;
    justify-content: center;
    /* align-items: center; */
    /* height: calc(100vh - 300px); */
    margin-top:  40px;
 }
 .notice-main-form-content{
    width: 700px;
    background-color: #FFFFFF;
    height: 500px;
    /* box-shadow: 0px 0px 10px lightblue; */
    border:1px solid lightgray;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
 }


 .notice-filters{
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    align-items: center;
 }

 .notice-table{
    margin-top: 20px;
    max-height: calc(100vh - 360px); /* Set a max height to enable scrolling */
    overflow-y: scroll; 
    /* padding:0px 20px; */
 }
 
 .notice-table::-webkit-scrollbar {
    width: 0; /* Set the width of the scrollbar to a minimal value */
  }
  
  .notice-table::-webkit-scrollbar-thumb {
    background: none; /* Set the scrollbar thumb to be transparent */
  }

 .notice-table-head{
    display: grid;
    grid-template-columns: repeat(13, minmax(0, 1fr));
    text-align: center;
    background-color: #0059B2;
    color: #FFFFFF;
    padding: 20px 0px;
    border-radius: 10px;
    position: sticky;
  top: 0;
  z-index: 1;
 }
 .notice-message{
    grid-column: span 3;
 }
 .notice-table-head>div:nth-child(8){
    grid-column: span 3;
    text-align: center;
 }

 .notice-table-head>div:first-child{
   grid-column: span 2;
   text-align: center;
 }


 .notice-table-body{
    display: grid;
    grid-template-columns: repeat(13, minmax(0, 1fr));
    text-align: center;
    padding: 20px 0px;
    border-radius: 25px;
    margin: 20px 10px;
    border: 1px solid lightgray;
    align-items: center;
    justify-content: center;
 }

 .notice-table-body>div:first-child{
   grid-column: span 2;
   text-align: center;
 }

 .notice-table-body>div:nth-child(8){
    grid-column: span 3;
 }

 .notice-table-body>div{
   padding: 0px 10px;
 }

 .notice-table-body:hover{
    transform: scale(1.01);
 }


 .notice-table-action{
    display: flex;
    justify-content: center;
    align-items: center;

 }
 .notice-table-action>div{
    margin-right: 10px;
 }

 .notice-table-action>div>button{
    border-radius: 5px;
    padding: 5px;
    cursor: pointer;
 }
 .notice-table-action>div:nth-child(3)>button{
    background-color: #ef4444;
    color: #FFFFFF;
    border: none;
 }

 .notice-table-action>div:nth-child(2)>button{
    background-color: #0ea5e9;
    color: #FFFFFF;
    border: none;
 }

 .notice-table-action>div:nth-child(1)>button{
    background-color: #6ee7b7;
    color: #FFFFFF;
    border: none;
 }`, "",{"version":3,"sources":["webpack://./src/components/HospitalNotices/HospitalNotice.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,0BAA0B;;IAE1B,yBAAyB;CAC5B;;CAEA;KACI,yBAAyB;KACzB,iBAAiB;KACjB,kBAAkB;KAClB,gBAAgB;KAChB,0BAA0B;KAC1B,iCAAiC;KACjC,aAAa;KACb,aAAa;KACb,iCAAiC;KACjC,kBAAkB;KAClB,YAAY;;CAEhB;;;;;;CAMA;KACI,0BAA0B;KAC1B,0BAA0B;KAC1B,yBAAyB;CAC7B;;CAEA;KACI,yBAAyB;KACzB,iBAAiB;KACjB,kBAAkB;KAClB,gBAAgB;KAChB,0BAA0B;KAC1B,2BAA2B;KAC3B,aAAa;KACb,iCAAiC;KACjC,kBAAkB;KAClB,YAAY;CAChB;;CAEA;GACE,8BAA8B;GAC9B,eAAe;GACf,2BAA2B;GAC3B,UAAU;GACV,6BAA6B;GAC7B,gBAAgB;GAChB,qBAAqB;CACvB;;CAEA;GACE,sBAAsB;GACtB,yBAAyB;GACzB,yBAAyB;GACzB,yBAAyB;GACzB,+BAA+B;GAC/B,yBAAyB;CAC3B;;CAEA;IACG,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,iCAAiC;IACjC,iBAAiB;CACpB;CACA;IACG,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,wCAAwC;IACxC,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;CACtB;;;CAGA;IACG,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;CACtB;;CAEA;IACG,gBAAgB;IAChB,+BAA+B,EAAE,yCAAyC;IAC1E,kBAAkB;IAClB,sBAAsB;CACzB;;CAEA;IACG,QAAQ,EAAE,sDAAsD;EAClE;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;EAClE;;CAED;IACG,aAAa;IACb,iDAAiD;IACjD,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB,MAAM;EACN,UAAU;CACX;CACA;IACG,mBAAmB;CACtB;CACA;IACG,mBAAmB;IACnB,kBAAkB;CACrB;;CAEA;GACE,mBAAmB;GACnB,kBAAkB;CACpB;;;CAGA;IACG,aAAa;IACb,iDAAiD;IACjD,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAI3B,mBAAmB;IACnB,uBAAuB;CAJ1B;;CAOA;GACE,mBAAmB;GACnB,kBAAkB;CACpB;;CAEA;IACG,mBAAmB;CACtB;;CAEA;GACE,iBAAiB;CACnB;;CAEA;IACG,sBAAsB;CACzB;;;CAGA;IACG,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;CAEtB;CACA;IACG,kBAAkB;CACrB;;CAEA;IACG,kBAAkB;IAClB,YAAY;IACZ,eAAe;CAClB;CACA;IACG,yBAAyB;IACzB,cAAc;IACd,YAAY;CACf;;CAEA;IACG,yBAAyB;IACzB,cAAc;IACd,YAAY;CACf;;CAEA;IACG,yBAAyB;IACzB,cAAc;IACd,YAAY;CACf","sourcesContent":[".notice-main{\n    width:calc(100vw - 202px);\n    height: calc(100vh - 38px);\n   \n    background-color: #F4F9FF;\n }\n \n .notice-div{\n     background-color: #FFFFFF;\n     margin-left: 15px;\n     position: absolute;\n     margin-top: 15px;\n     width: calc(100vw - 265px);\n     /* height: calc(100vh - 100px); */\n     height: 100vh;\n     padding: 20px;\n     box-shadow: 0px 0px 7px lightblue;\n     border-radius: 5px;\n     border: none;\n    \n }\n\n\n \n \n \n .notice-min{\n     width: calc(100vw - 100px);\n     height: calc(100vh - 38px);\n     background-color: #F4F9FF; \n }\n \n .notice-div-min{\n     background-color: #FFFFFF;\n     margin-left: 15px;\n     position: absolute;\n     margin-top: 15px;\n     width: calc(100vw - 165px);\n     height: calc(100vh - 100px);\n     padding: 20px;\n     box-shadow: 0px 0px 7px lightblue;\n     border-radius: 5px;\n     border: none;\n }\n\n .notice-tab>div{\n   background-color: transparent ;\n   margin-top: 0px;\n   justify-content: flex-start;\n   left: auto;\n   position: absolute !important;\n   padding-top: 0px;\n   width: 80% !important;\n }\n\n .notice-tab>div>div>button.Mui-selected{\n   border: 1px solid gray;\n   background-color: #0059B2;\n   color: #FFFFFF !important;\n   /* border-radius: 10px; */\n   /* color: #0000ff !important; */\n   /* transform: scale(1); */\n }\n\n .notice-main-form{\n    display: flex;\n    justify-content: center;\n    /* align-items: center; */\n    /* height: calc(100vh - 300px); */\n    margin-top:  40px;\n }\n .notice-main-form-content{\n    width: 700px;\n    background-color: #FFFFFF;\n    height: 500px;\n    /* box-shadow: 0px 0px 10px lightblue; */\n    border:1px solid lightgray;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n }\n\n\n .notice-filters{\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n    align-items: center;\n }\n\n .notice-table{\n    margin-top: 20px;\n    max-height: calc(100vh - 360px); /* Set a max height to enable scrolling */\n    overflow-y: scroll; \n    /* padding:0px 20px; */\n }\n \n .notice-table::-webkit-scrollbar {\n    width: 0; /* Set the width of the scrollbar to a minimal value */\n  }\n  \n  .notice-table::-webkit-scrollbar-thumb {\n    background: none; /* Set the scrollbar thumb to be transparent */\n  }\n\n .notice-table-head{\n    display: grid;\n    grid-template-columns: repeat(13, minmax(0, 1fr));\n    text-align: center;\n    background-color: #0059B2;\n    color: #FFFFFF;\n    padding: 20px 0px;\n    border-radius: 10px;\n    position: sticky;\n  top: 0;\n  z-index: 1;\n }\n .notice-message{\n    grid-column: span 3;\n }\n .notice-table-head>div:nth-child(8){\n    grid-column: span 3;\n    text-align: center;\n }\n\n .notice-table-head>div:first-child{\n   grid-column: span 2;\n   text-align: center;\n }\n\n\n .notice-table-body{\n    display: grid;\n    grid-template-columns: repeat(13, minmax(0, 1fr));\n    text-align: center;\n    padding: 20px 0px;\n    border-radius: 25px;\n    margin: 20px 10px;\n    border: 1px solid lightgray;\n }\n\n .notice-table-body{\n    align-items: center;\n    justify-content: center;\n }\n\n .notice-table-body>div:first-child{\n   grid-column: span 2;\n   text-align: center;\n }\n\n .notice-table-body>div:nth-child(8){\n    grid-column: span 3;\n }\n\n .notice-table-body>div{\n   padding: 0px 10px;\n }\n\n .notice-table-body:hover{\n    transform: scale(1.01);\n }\n\n\n .notice-table-action{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n }\n .notice-table-action>div{\n    margin-right: 10px;\n }\n\n .notice-table-action>div>button{\n    border-radius: 5px;\n    padding: 5px;\n    cursor: pointer;\n }\n .notice-table-action>div:nth-child(3)>button{\n    background-color: #ef4444;\n    color: #FFFFFF;\n    border: none;\n }\n\n .notice-table-action>div:nth-child(2)>button{\n    background-color: #0ea5e9;\n    color: #FFFFFF;\n    border: none;\n }\n\n .notice-table-action>div:nth-child(1)>button{\n    background-color: #6ee7b7;\n    color: #FFFFFF;\n    border: none;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
